"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commissionConfigApi = commissionConfigApi;
exports.commissionLevelConfigApi = commissionLevelConfigApi;
exports.commissionUpdateConfigApi = commissionUpdateConfigApi;
exports.commissionUpdateLevelConfigApi = commissionUpdateLevelConfigApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @description 获取佣金配置
 */
function commissionConfigApi() {
  return (0, _request.default)({
    url: "admin/platform/commission/withdraw/detail",
    method: 'GET'
  });
}

/**
 * 保存佣金配置
 */
function commissionUpdateConfigApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/commission/withdraw/save',
    method: 'POST',
    data: data
  });
}

/**
 * @description 获取佣金档位配置
 */
function commissionLevelConfigApi() {
  return (0, _request.default)({
    url: "admin/platform/commission/config/getConfigs",
    method: 'GET'
  });
}

/**
 * 保存佣金档位配置
 */
function commissionUpdateLevelConfigApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/commission/config/saveConfigs',
    method: 'POST',
    data: data
  });
}